<template>
  <v-btn v-bind="$attrs" :block="block" :color="variantColor" @click="$emit('click', $event)">
    <slot />
  </v-btn>
</template>

<script>
export default {
  name: 'BButton',
  inheritAttrs: false,
  props: {
    block: { type: Boolean, default: false },
    variant: { type: String, default: 'primary' }
  },
  emits: ['click'],
  computed: {
    variantColor () {
      if (this.variant === 'success' || this.$attrs.class?.includes('btn-success')) return 'success'
      if (this.$attrs.class?.includes('btn-cancel')) return 'grey'
      return 'primary'
    }
  }
}
</script>
